export default __webpack_public_path__ + "static/media/popup_3.7a9bd3eb.jpeg";